import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);


let store = new Vuex.Store({
  state: {
	modal: {
		show: false,
		component: null,
		title: null,
		footer: false,
		hideLogo: false,
		closeBackdrop: true,
		embedId: null
	},
	cookie: false,
	token: null
  },
  mutations: {
  	showModal(state, { title, component, footer, category, hideLogo, closeBackdrop, embedId }){
			state.modal.show = true
			state.modal.title = title
			state.modal.component = component
			state.modal.footer = footer
			state.modal.leadCategory = category
			state.modal.hideLogo = hideLogo
			state.modal.closeBackdrop = closeBackdrop
			state.modal.embedId = embedId	
  	},
  	hideModal(state){
			state.modal.show = false
			state.modal.title = null
			state.modal.component = null
			state.modal.footer = false
  	},
  	setStateData(state, {data, key}){
  		state[key] = data
  		if (!store._vm.$session.exists()){
			store._vm.$session.start()  
		}
  		store._vm.$session.set(key, state[key])
  		// console.log('state', state[key])
  	}
  },
  actions: {
		showModal(context, {title, component, footer, category, hideLogo, closeBackdrop, embedId}) {
			context.commit ('showModal', {
				title,
				component,
				footer,
				category,
				hideLogo,
				closeBackdrop,
				embedId
			})
		},

		hideModal(context){
			context.commit ('hideModal')
		},
		setStateData(context, {data, key}){
			context.commit ('setStateData', {
				data,
				key
			})
		}
  },
  getters: {
  	getToken: state => state.token,
  	getCookie: state => state.cookie,
  	getEmbedId: state => state.modal.embedId
  },
  modules: {}
});


export default store